import * as THREE from "three";
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import RAPIER from '@dimforge/rapier3d-compat';
import { transformToLocalGeometry } from '../../rapier/helper/transformToLocalGeometry';

// Sound

export class Ground {
  private world: RAPIER.World | null = null;
  private groundBody: RAPIER.RigidBody | null = null;
  private groundLoaded = false;
  private groundMesh: THREE.Object3D | null = null;

  constructor(assetsBase: string, loader: GLTFLoader, scene: THREE.Scene, world?: RAPIER.World) {
    this.world = world || null;

    const dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.6/");
    loader.setDRACOLoader(dracoLoader);

    loader.load(
      assetsBase + '/models/work-025/ground.glb',
      (gltf) => {
        const ground = gltf.scene;
        scene.add(ground);

        this.groundMesh = ground;
        this.groundLoaded = true;
        // 物理ボディを作成（地面）
        this.createGroundPhysics();
      }
    );
  }

  /**
   * 物理演算ワールドを後から設定
   */
  public setWorld = (world: RAPIER.World): void => {
    this.world = world;
    this.createGroundPhysics();
  }

  /**
   * 地面の物理ボディを作成
   */
  private createGroundPhysics = (): void => {
    if (!this.world || !this.groundLoaded || !this.groundMesh || this.groundBody) return;

    this.groundMesh.updateWorldMatrix(true, true);
    const geometryData = transformToLocalGeometry(this.groundMesh);
    if (!geometryData) return;

    const groundDesc = RAPIER.RigidBodyDesc.fixed()
      .setTranslation(geometryData.origin.x, geometryData.origin.y, geometryData.origin.z)
      .setRotation(new RAPIER.Quaternion(
        geometryData.rotation.x,
        geometryData.rotation.y,
        geometryData.rotation.z,
        geometryData.rotation.w,
      ));
    this.groundBody = this.world.createRigidBody(groundDesc);

    const groundCollider = RAPIER.ColliderDesc.trimesh(geometryData.vertices, geometryData.indices)
      .setRestitution(0.3)
      .setFriction(0.8);
    this.world.createCollider(groundCollider, this.groundBody);
  }
}
